module.exports = __webpack_public_path__ + "img/teddy-bear.78baab4c.png";